import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import UiKitButton from 'components/UiKit/Button';

const UpdateReportButton = ({ disabled }) => {
  const { values, handleSubmit } = useFormikContext();
  const handleClick = () => {
    handleSubmit(values);
  };
  return (
    <div className="w-full flex shrink-0 justify-end p-10px bg-white border-t border-neutral-20">
      <UiKitButton variant="primary" disabled={disabled} onClick={handleClick}>
        Update Report
      </UiKitButton>
    </div>
  );
};

UpdateReportButton.propTypes = {
  disabled: PropTypes.bool.isRequired
};

export default UpdateReportButton;
